import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DownloadSVG, PlaySVG } from '@sbercloud/uikit-product-icons';
import { HERO_EVENT_BUTTONS } from '../../constants';
export var HERO_BUTTON_META = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, HERO_EVENT_BUTTONS.Watch, {
  label: 'Смотреть запись',
  icon: PlaySVG
}), HERO_EVENT_BUTTONS.WatchLater, {
  label: 'Запись скоро будет',
  icon: PlaySVG,
  disabled: true
}), HERO_EVENT_BUTTONS.AdditionalMaterials, {
  label: 'Получить материал',
  icon: DownloadSVG
}), HERO_EVENT_BUTTONS.Registration, {
  label: 'Регистрация'
}), HERO_EVENT_BUTTONS.RegistrationClosed, {
  label: 'Регистрация закрыта',
  disabled: true
});